export var IdAssetBundleBalloon;
(function (IdAssetBundleBalloon) {
    IdAssetBundleBalloon["Balloon_1"] = "Balloon_1";
    IdAssetBundleBalloon["BalloonShadow"] = "BalloonShadow";
})(IdAssetBundleBalloon || (IdAssetBundleBalloon = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/static/IdAssetBundleBalloon.ts
// module id = 810
// module chunks = 3